'use client';

import RtuSection1 from '@enlighten/landing/dist/rtu/@section1';

export default function Section1() {
	return (
		<RtuSection1
			type="home"
			onNewClick={() => {
				window.open('https://forms.gle/e5epLKyJwh9Ubo2i8', '_blank');
			}}
			onOtherClick={() => {
				window.open('https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=16730270323609', '_blank');
			}}
		/>
	);
}
